<template>
  <v-container py-0>
    <v-progress-linear
      :active="loading"
      height="3"
      :indeterminate="true"
      class="mb-3"
    />
    <v-flex offset-md3 md6 xs12>
      <v-card>
        <v-card-text>
          <v-layout wrap row>
            <v-flex md6 xs12 px-2>
              <v-text-field
                v-model="smtp.host"
                v-validate="'required'"
                :label="$t('fields.global.host')"
                :data-vv-name="$t('fields.global.host')"
                :error-messages="errors.collect($t('fields.global.host'))"
              />
            </v-flex>
            <v-flex md6 xs12 px-2>
              <v-text-field
                v-model="smtp.port"
                v-validate="'required'"
                :label="$t('fields.global.port')"
                type="number"
                :data-vv-name="$t('fields.global.port')"
                :error-messages="errors.collect($t('fields.global.port'))"
              />
            </v-flex>
            <v-flex md6 xs12 px-2>
              <v-text-field
                v-model="smtp.username"
                v-validate="'required'"
                :label="$t('fields.global.username')"
                :data-vv-name="$t('fields.global.username')"
                :error-messages="errors.collect($t('fields.global.username'))"
              />
            </v-flex>
            <v-flex md6 xs12 px-2>
              <v-text-field
                v-model="smtp.password"
                v-validate="'required'"
                :label="$t('fields.users.password')"
                :data-vv-name="$t('fields.users.password')"
                :error-messages="errors.collect($t('fields.users.password'))"
              />
            </v-flex>
            <v-flex md2 sm6 xs12 px-2>
              <v-switch
                v-model="smtp.active"
                :label="$t('fields.global.active')"
                color="primary"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <meta-button :disabled="loading" type="reset" @click="clear" />
          <meta-button :loading="loading" type="update" @click="submit" />
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'TabSMTP',
  data() {
    return {
      smtp: { active: true },
    }
  },
  watch: {
    selected: {
      handler: function () {
        this.init()
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (this.selected && this.selected.smtp) {
      this.smtp = { ...this.selected.smtp }
    }
  },
  computed: {
    ...mapState({
      selected: (state) => state.entities.selected,
      loading: (state) => state.entities.loading,
    }),
  },
  methods: {
    ...mapActions({
      setUpdate: 'entities/update',
    }),
    submit() {
      this.validate().then((valid) => {
        if (!valid) return
        const payload = { _id: this.selected._id, smtp: this.smtp }
        this.setUpdate(payload)
      })
    },
    init() {
      if (this.selected && this.selected.smtp) {
        this.smtp = { ...this.selected.smtp }
      }
    },
    clear() {
      this.smtp = { active: true }
    },
  },
}
</script>
